import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";
import moment from "moment/moment";
import {Badge} from 'primereact/badge';

const CheckinexportListComponent = (props) => {

  const {t} = props;
  const [checkinexports, setCheckinexports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [retryingId, setRetryingId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [statusDict, setStatusDict] = useState({});
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  const loadLazyTimeout = useRef(null);
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout.current) {
      clearTimeout(loadLazyTimeout.current);
    }
    loadLazyTimeout.current = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      apiCall('get', '/api/v2/export/checkin' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setCheckinexports(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, 150);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const downloadFile = (exportId) => {
    setLoading(true);
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + `/api/v2/export/checkin/${exportId}/download`,
      responseType: 'blob', 
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `export_${moment().format('YYYYMMDD_HHmm')}.xlsx`);
      
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    }).catch(error => {
      window.App.toastShow('error', t('error'), 'Sikertelen letöltés');
    }).finally(() => {
      setLoading(false);
    });
  };

  const handleRetry = async (row) => {
    setRetryingId(row.id);
    try {
      await apiCall('post', `/api/v2/export/checkin/${row.id}/retry`, {});
      window.App.toastShow('success', 'Az export újra feldolgozási sorba került.');
      setRefreshKey(key => key + 1);
    } catch (error) {
      window.App.toastShow('error', t('error'), error.response?.data?.message || error.toString(), '', error.response);
    } finally { setRetryingId(null); }
  };

  const actionBodyTemplate = (row) => {
    const done = String(row.status).toLowerCase() === 'done';
    const fileId = row.file_id || row.file?.id;
    return <>
      {!done && <Button icon="pi pi-refresh" className="p-button-secondary p-mr-2"
        aria-label="Export újraküldése" tooltip="Export újraküldése"
        loading={retryingId === row.id} disabled={retryingId !== null}
        onClick={() => handleRetry(row)} />}
      {done && fileId && <Button icon="pi pi-download" className="p-button-info"
        tooltip={t('download')} onClick={() => downloadFile(row.id)} />}
    </>;
  };

  const formatPeriod = value => value && moment(value).isValid() ? moment(value).format('YYYY-MM-DD') : '—';

  const loadStatusDict = () => {
    return apiCall('get', `/api/v2/dictionary/export-status?_ts=${Date.now()}`)
      .then(response => {
        const data = response?.data?.data;

        if (Array.isArray(data)) {
          const dict = data.reduce((acc, it) => {
            if (it?.key != null && it?.value != null) {
              acc[String(it.key)] = String(it.value);
              acc[String(it.key).toLowerCase()] = String(it.value);
            }
            return acc;
          }, {});
          setStatusDict(dict);
          return;
        }

        if (data && typeof data === 'object') {
          setStatusDict(data);
          return;
        }

        setStatusDict({});
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        setStatusDict({});
      });
  };

  const statusLabel = (status) => {
    if (!status) return '';
    const s = String(status);
    return statusDict?.[s] ?? statusDict?.[s.toLowerCase()] ?? s;
  };

  const getStatusSeverity = (statusRaw) => {
    const s = (statusRaw ?? '').toString().trim().toLowerCase();
    if (s === 'done') return 'success';
    if (s === 'processing') return 'info';
    if (s === 'pending') return 'warning';
    return 'danger';
  };

  useEffect(() => {
    loadLazyData();
    return () => clearTimeout(loadLazyTimeout.current);
  }, [lazyParams, window.App.state.rerenderCheckinexportList, refreshKey]);

  useEffect(() => { loadStatusDict(); }, []);

  useEffect(() => {
    const timer = setInterval(() => setRefreshKey(key => key + 1), 10000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const refresh = () => setRefreshKey(key => key + 1);
    window.addEventListener('checkinexportListRefresh', refresh);
    return () => window.removeEventListener('checkinexportListRefresh', refresh);
  }, []);

  return (
    <>
      <Button icon="pi pi-refresh" label={t('refresh')} className="p-button-text p-mb-2"
        disabled={loading} onClick={() => setRefreshKey(key => key + 1)} />
      <DataTable scrollable scrollDirection="horizontal" size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={checkinexports} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        <Column field="id" header="ID" sortable />
        <Column header="Időszak kezdete" body={row => formatPeriod(row.parameters?.date_from)} />
        <Column header="Időszak vége" body={row => formatPeriod(row.parameters?.date_until)} />
        <Column field="status" header={t('columnStatus2')} sortable filter body={(rowData) => <Badge value={statusLabel(rowData.status)} severity={getStatusSeverity(rowData.status)} />}></Column>
        <Column field="total_rows" header={t('columnTotalRows')} sortable body={(rowData) => rowData.total_rows ?? 0} ></Column>
        <Column field="processed_rows" header={t('columnProcessedRows')} sortable body={(rowData) => rowData.processed_rows ?? 0}></Column>


        <Column header="Hiba" body={row => (row.error_log || []).join('; ')} />
        <Column body={actionBodyTemplate} frozen alignFrozen="right" style={{minWidth: '7rem'}} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(CheckinexportListComponent);
